import React from 'react';
import {
  Box,
  Container
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import ProblemsGrid from './ProblemsGrid';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ProblemsView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Problems"
    >
      <Container maxWidth="lg">
        <Box mt={3}>
          <ProblemsGrid style={{flex:0.5}}/>
        </Box>
      </Container>
    </Page>
  );
};

export default ProblemsView;
